/*
 *
 * EconomicConditionsSelectorModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 24-Sep-2025
*/

import EconomicConditionsSelectorModal from './EconomicConditionsSelectorModalContainer'

export default EconomicConditionsSelectorModal
